import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import FormBuscarPersona from '../formularios/FormBuscarPersona';
import FormPersona from '../tramites/formularios/FormPersona';
import Loading from '../common/Loading';

import insertPersona from '../../graphql/mutations/persona/insertPersona.graphql';
import validarPersonaConRenaper from '../../graphql/mutations/persona/validarPersonaConRenaper.graphql';
// import getPersonaPorDocumento from '../../graphql/querys/personas/getPersonaPorDocumento.graphql';
import getPersonaPorDocumentoyGenero from '../../graphql/querys/personas/getPersonaPorDocumentoyGenero.graphql';
import getPersonaPorRenaper from '../../graphql/querys/personas/getPersonaPorRenaper.graphql';
import getUsuario from '../../graphql/querys/auth/getUsuario.graphql';

import _ from 'lodash';
import { errorService } from '../../graphql/utils/utils';

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(validarPersonaConRenaper, {
    name: 'validarPersonaConRenaper',
  }),
  graphql(getUsuario)
)
class BuscarYCrearPersona extends Component {
  state = {
    loading: false,
    persona: {},
    step: 0,
    requeridoDNI: true,
  };

  componentDidMount() {
    if (
      this.props.persona &&
      this.props.persona.dni &&
      this.props.requeridoDNI == false
    ) {
      this.setState({
        requeridoDNI: false,
        step: 1,
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // console.log('Analizo si se conoce o no el DNI: ');
    // console.log(nextProps);
    if (
      nextProps.requeridoDNI != undefined &&
      nextProps.requeridoDNI == false
    ) {
      // console.log('ENTRO');
      this.setState({
        requeridoDNI: false,
        step: 1,
      });
    }

    if (nextProps.requeridoDNI != undefined && nextProps.requeridoDNI == true) {
      //ENTRO Y VAMOS A REGENERAR TODO
      this.setState({
        requeridoDNI: true,
        step: 0,
      });
    }
  }

  buscarPersona = datos => {
    this.setState({
      ...this.state,
      loading: true,
    });
    console.log(datos);
    this.props.client
      .query({
        query: getPersonaPorDocumentoyGenero,
        variables: { tipo_doc: datos.tipo_doc, num_doc: datos.num_doc, genero: datos.genero },
        fetchPolicy: 'network-only',
      })
      .then(respuestaPersona => {
        if (respuestaPersona.data.getPersonaPorDocumento) {
          // Si encuentra en nuestra base validamos los datos con renaper
          const persona = respuestaPersona.data.getPersonaPorDocumento;
          const { _id, tipo_doc, num_doc } = persona;

          this.props
            .validarPersonaConRenaper({
              variables: { _id, tipo_doc, num_doc },
            })
            .then(resValidar => {
              let personaValidada = resValidar.data.validarPersonaConRenaper;
              // console.log('RESPUESTA VALIDAR RENAPER', personaValidada);

              if (personaValidada) {
                this.setState({
                  loading: false,
                  persona: personaValidada,
                });
              } else {
                this.setState({
                  ...this.state,
                  persona: respuestaPersona.data.getPersonaPorDocumento,
                  loading: false,
                });
              }

              notification.success({
                message: 'Persona encontrada',
                description: 'Se encontro la persona correctamente',
              });
            })
            .catch(err => {
              console.log('ERROR AL VALIDAR CON RENAPER', err);
            });
        } else {
          console.log("NO fue una buena persona")
          // si no encuentra en nuestra base buscamos en renaper

          this.props.client
            .query({
              query: getPersonaPorRenaper,
              variables: { tipo_doc: datos.tipo_doc, num_doc: datos.num_doc, genero: datos.genero },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              if (res.data.getPersonaPorRenaper.num_doc) {
                this.setState({
                  persona: res.data.getPersonaPorRenaper,
                  loading: false,
                });

                notification.success({
                  message: 'Persona encontrada',
                  description: 'Se encontro la persona correctamente',
                });
              } else {
                //Cancelamos el spinner y reiniciamos la persona por si existen datos basura.
                this.setState({
                  ...this.state,
                  persona: {
                    tipo_doc: datos.tipo_doc,
                    num_doc: datos.num_doc,
                    genero: datos.genero
                  },
                  loading: false,
                });

                notification.error({
                  message: 'Persona no encontrada',
                  description: 'La persona buscada no existe',
                });
              }
            })
            .catch(err => {
              console.log('Error al llamar getPersonaPorRenaper =>', err);
            });
        }

        this.siguientePaso();
      });
  };

  guardarPersona = persona => {
    let personaVieja = {
      ...this.state.persona,
    };

    //Y BORRO LAS PROPIEDADES COMO ID Y TYPENAME PARA COMPARAR LAS RESTANTES QUE COMPARTEN AMBOS OBJETOS
    delete personaVieja._id;
    delete personaVieja.__typename;

    if (persona.fecha_nacimiento) {
      persona.fecha_nacimiento = persona.fecha_nacimiento.getTime();
    }

    if (personaVieja.localidad) {
      personaVieja.localidad = personaVieja.localidad._id;
    }

    if (!_.isEqual(personaVieja, persona)) {
      //Este caso nos indica que existe un cambio en la persona.

      // console.log("Entre a guardar la persona!");

      this.props
        .createPers({
          variables: { persona: persona },
          options: {
            refetchQueries: [
              {
                query: getPersonaPorDocumentoyGenero,
                variables: {
                  tipo_doc: persona.tipo_doc,
                  num_doc: persona.num_doc,
                  genero: persona.genero,
                },
              },
            ],
          },
        })
        .then(resPersona => {
          let personaNueva = resPersona.data.insertPersona;

          this.setState(
            {
              loading: false,
              persona: {},
              step: 0,
            },
            function() {
              this.props.obtenerPersona(personaNueva);
            }
          );
        })
        .catch(err => {
          console.log('Existio un error a la hora de crear la persona');
          console.log(err);
          errorService(err, {
            tipo_doc: persona.tipo_doc,
            num_doc: persona.num_doc,
          });
          Modal.error({
            title: 'Error en la creacion de la persona',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    } else {
      // console.log("no existio necesidad de guardar la persona");
      let personaGuardada = { ...this.state.persona };
      this.setState(
        {
          loading: false,
          persona: {},
          step: 0,
        },
        function() {
          this.props.obtenerPersona(personaGuardada);
        }
      );
    }
  };

  siguientePaso = () => {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let { step } = this.state;
    return (
      <div>
        {step === 0 && (
          <FormBuscarPersona
            onSubmit={this.buscarPersona}
            onCancel={this.props.onCancel}
          />
        )}
        {step === 1 && (
          <FormPersona
            className="formularios"
            onSubmit={this.guardarPersona}
            onAnterior={this.anteriorPaso}
            persona={this.state.persona}
            onFinish={this.props.onFinish}
            multiple={this.props.multiple}
            requiereDNI={this.state.requeridoDNI}
          />
        )}
      </div>
    );
  }
}

export default withApollo(BuscarYCrearPersona);
